/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Cashapp: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <rect width='32' height='32' rx='16' fill='#00D64F' />
    <path
      d='M18.7 8.67c.15 0 .26.15.23.3l-.3 1.45c1 .33 1.82.92 2.33 1.65.07.1.05.25-.05.33l-1.24 1.08c-.1.1-.27.07-.35-.05a3.33 3.33 0 0 0-2.68-1.28c-1.15 0-1.92.55-1.92 1.34 0 .65.57.99 2.34 1.4 2.25.51 3.28 1.5 3.28 3.18 0 2.1-1.6 3.65-4.12 3.81l-.24 1.25a.24.24 0 0 1-.24.2H13.8c-.16 0-.27-.15-.23-.31l.3-1.4a5.08 5.08 0 0 1-2.83-2.03.25.25 0 0 1 .05-.33l1.36-1.12c.11-.1.27-.06.36.06a3.69 3.69 0 0 0 3.13 1.68c1.19 0 2.09-.62 2.09-1.5 0-.69-.45-1-1.96-1.34-2.6-.58-3.64-1.6-3.64-3.28 0-1.94 1.54-3.41 3.86-3.6l.25-1.29c.02-.12.12-.2.23-.2h1.92Z'
      fill='#fff'
    />
  </React.Fragment>
)
